//src/components/rental-managers/AccessManagementBenefits.jsx

import React from 'react';
import { Box, Typography, Grid, List, ListItem, ListItemText } from '@mui/material';
import AccessManagementBenefitsStyles from './AccessManagementBenefits.styles';

const benefits = [
  'Track hourly maintenance time with access logs and motion-activated doorbell camera',
  'Provide Maintenance access with one-time passcodes that terminate when work is done',
  'Monitor Vacant Properties',
  'Know when tenants have vacated or moved in automatically',
  'Maintenance Scheduling Automation/Tenant Notification',
  'Keep Properties Secure - No key copies, no lockouts, no lockboxes or lockbox codes to change after entry access',
  'No more lockbox expenses for mechanical lockboxes that rust or freeze',
  'Tenant Move-In/Move-Out with a few button clicks',
  'Increased Efficiency, Quicker Turnovers, Less Staff Hours, Fewer Blind Spots, Less Drive Time/Gas Emissions, and Full Access Control',
  'No Long-Term Contract. Cancel anytime.',
  'Easy keyless transfer at property sale with asset assignment at closing to another user and hardware compatible with ShowingTime.',
];

const AccessManagementBenefits = () => {
  return (
    <Box sx={AccessManagementBenefitsStyles.container}>
      <Grid container spacing={6} alignItems="center">
        {/* Left Side - Benefits List */}
        <Grid item xs={12} md={6} sx={AccessManagementBenefitsStyles.textContainer}>
          <Typography variant="h5" sx={AccessManagementBenefitsStyles.title}>
            ACCESS MANAGEMENT BENEFITS
          </Typography>

          <List sx={AccessManagementBenefitsStyles.list}>
            {benefits.map((benefit, index) => (
              <ListItem key={index} sx={AccessManagementBenefitsStyles.listItem}>
                <ListItemText
                  primary={
                    <Typography component="span" sx={benefit.includes(':') ? AccessManagementBenefitsStyles.boldText : null}>
                      {benefit}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* Right Side - Single Image Displayed Down the Page */}
        <Grid item xs={12} md={6} sx={AccessManagementBenefitsStyles.imageContainer}>
          <img 
            src="/images/access.png" 
            alt="Access Management Benefits" 
            style={AccessManagementBenefitsStyles.image}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default AccessManagementBenefits;
